export default {
  base: {
    search: "Search",
    advance_search: "Advance Search",
    reset: "Reset",
    min: "min",
    max: "max",
    to: "to",
    no_pictures: "No Pictures",
    add: "Add",
    add1: "+ Add",
    to_view: "View",
    edit: "Edit",
    edit1: "Edit",
    delete: "Delete",
    copy: "Copy",
    copying: "Copying...",
    operation: "Actions",
    save: "Save",
    confirm: "Confirm",
    done: "Done",
    cancel: "Cancel",
    success: "Success",
    fail: "Fail",
    delete_alert_role_title: "Delete failed!",
    delete_alert_role_info:
      "This role contains user information. Please delete all users under this role or unbind this role before deleting!",
    delete_alert_title: "Are you sure?",
    delete_alert_info: "You won't be able to revert this!",
    copy_alert_title: "Are you sure you want to copy this data?",
    delete_alert_completed: "Completed",
    add_success: "Success",
    edit_success: "Success",
    delete_success: "Success",
    copy_success: "Success",
    search_id: "Search",
    upload_file_limit:
      "Only jpg/png files can be uploaded, and the size cannot exceed 50 MB",
    upload_picture_limit:
      "Only jpg/png files can be uploaded, and the size cannot exceed 50 MB",
    upload_excel_limit:
      "Only excel files can be uploaded, and the size cannot exceed 50 MB",
    no_data: "No Data",
    hint_name: "The name cannot be empty!",
    none: "None",
    total: "Total",
    total_unit: "",
    previous_page: "Previous",
    next_page: "Next",
    jump_to: "Go to",
    jump_to_unit: "Page",
    empty: "Empty",
    disabled: "Disabled",
    enabled: "Enabled",
    request403: "Permission Denied",
    request403_to_login:
      "Login status invalid, jump to login page after 3 seconds",
    grant_all_garment: "Garment editable",
    grant_all_garment_view: "Garment readonly",
    grant_all_fabric: "Fabric editable",
    grant_all_fabric_view: "Fabric readonly",
    grant_all_yarn: "Yarn editable",
    grant_all_yarn_view: "Yarn readonly",
    grant_all_fibre: "Fibre editable",
    grant_all_fibre_view: "Fibre readonly",
    grant_all_textile_bedware: "Bedding editable",
    grant_all_textile_bedware_view: "Bedding readonly",
    grant_all_textile_home_decor: "Household textiles editable",
    grant_all_textile_home_decor_view: "Household textiles readonly",
    grant_all_textile_industrial: "Industrial textiles editable",
    grant_all_textile_industrial_view: "Industrial textiles readonly",
    grant_all_textile_kitchen: "Kitchen and bathroom supplies editable",
    grant_all_textile_kitchen_view: "Kitchen and bathroom supplies readonly",
    english: "English",
    chinese: "中文",
    preview: "Preview",
    is_public: "is public",
    user_info: "User Info",
    user_center_name: "User Name",
    change_password: "Change Password",
    original_password: "Original Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    confirm_password_info: "The passwords entered twice are inconsistent",
    change_success: "Change Password Success",
    filter_password:
      "The new password is consistent with the original password, please modify it again",
    hint_code: "HS Code is required",
    No: "No.",
    resetFile:
      "Uploading a new file will overwrite the original file. Do you want to continue?",
    show: "Show",
    requiredinformation: "Please fill in all required information",
    delete_alert_hscode_info:
      "This code contains subset information. Please delete all subset information under this code before deleting this code!",
    delete_alert_error_title: "Error Message",
    alert_message_info: "Prompt Information",
    requireGroupAndindicator:
      "Please fill in the group name and indicator information",
    requireIndicator: "Please fill in the indicator name",
    sameIndicator: "Duplicate Indicator Name within the same group",
    viewDetails: "View Details",
    cannotEdit: "The system preset content cannot be modified",
    noDetailedInfo: "No detailed information was found",
    quantity: "quantity",
    needInfo:
      "When yes, it is necessary to fill in some threshold values and compliance methods",
    start_date: "Start date",
    end_date: "End date",
    permanent: "Permanent",
  },
  upload: {
    title: "Drop files here or click to upload",
    title1: "Click to upload images, videos, and documents",
    limit: "Upload file size limit：",
    limit1: "The file size does not exceed",
    type: "Support PPT、PDF、EXCEL、WORD、PNG、JPEG、JPG、MP4、MOV",
    type1:
      "Supports Excel Word、PDF、PNG、JPEG、JPG， The file size should not exceed 50M",
    typeImage: "Support PNG、JPEG、JPG",
    typeExcel: "Support Excel file format",
    typeWordPdf: "Support PDF、WORD、image",
    btn: "Upload",
    notSameFile:
      "A file with the same name already exists, cannot be uploaded again!",
    notCorrectType: "Please upload the correct file type",
    notCorrectType1:
      "Please upload the correct file type, Supports Excel Word、PDF、PNG、JPEG、JPG， The file size should not exceed 50M",
    file: "Files",
    uploadedFile: "Uploaded File",
    uploadedFile1: "Please upload the file",
    uploadedFile1Imag: "Click to upload images",
    uploadSuccess: "Upload Successfully",
    fileSizeLimit: "Exceeding the upload file size limit of 50M",
    fileTypeLimit: "Please upload pictures or PDF",
    fileTypeLimit1:
      "Supports PDF, PNG, and JPGE file formats, with file sizes not exceeding 50M",
    fileTypeLimit2:
      "Supports PNG, and JPGE file formats, with file sizes not exceeding 50M",
    noUpload: "No upload files",
  },
  menu: {
    home: "Home Page",
    garment: "Garment Database",
    fabric: "Fabric Database",
    yarn: "Yarn Database",
    fiber: "Fibre Database",
    hometextile: "Hometextile Database",
    textile_bedware: "Bedding Database",
    textile_home_decor: "Household Textiles Database",
    textile_industrial: "Industrial Textiles Database",
    textile_kitchen: "Kitchen and Bathroom Supplies Database",
    textile: "Industrial Textiles Database",
    hscode_management: "HS Code Management",
    product_template: "Product Database",
    system_management: "System Management",
    role: "Role",
    user: "User",
    permission: "Permission",
    my: "My",
    account: "Account Management",
    product_line: "Product line management",
    product: "Product management",
    business_information_management: "Business User Management",
    business_products_management: "Product Certification Management",
    supplyChain: "Supply Chain Management",
    lang: "Language Management",
  },
  home: {
    title: "FBD—Big Data Technology Platform for Textile Supply Chain",
    supplier: "Supplier",
    customers: "Customers",
    products: "Products",
    market: "Market",
    inventory: "Inventory",
    quality: "Quality",
    comfort: "Sensory comfort",
    traceability: "Traceability",
    circularity: "Circularity",
    GHG: "GHG Footprints",
    social: "ESG",
  },
  attribute: {
    base: "Basic Information",
    other: "Other Information",
    indicat: "Traceability Indicators",
    value: "Value",
    defaultvalue: "Default Value",
    unit: "Unit",
    id: "ID",
    name: "Name",
    type: "Type",
    size: "Size",
    size1: "Size",
    brand: "Brand",
    brand_name: "Brand Name",
    supplier: "Supplier",
    cost: "Cost",
    price: "Price",
    price_unit: "euro/piece",
    price_unit1: "euro/ton",
    stock: "Inventory",
    stock_unit: "piece",
    stock_unit1: "ton",
    style: "Style",
    fitting: "Fitting",
    code: "HS Code",
    structure: "Structure",
    safety: "Safety",
    protection: "Protection",
    features: "Features",
    others: "Others",
    composition: "Composition",
    designer: "Designer",
    body_coverage_ratio: "Body Coverage Ratio",
    manufacturer: "Manufacturer",
    picture: "Picture",
    water_contact_angle: "Water Contact Angle",
    water_contact_angle_unit: "deg",
    percentage: "%",
    number: "Number",
    diameter: "Diameter",
    density: "Density",
    radius: "Radius",
    phase_change_material_add_on_level: "Phase Change Material Add-on Level",
    latent_heat_of_fusion: "Latent Heat Of Fusion",
    latent_heat_of_fusion_unit: "cal/g",
    melting_point: "Melting Point",
    thermal_conductivity_of_liquid_pcm: "Thermal Conductivity Of Liquid PCM",
    thermal_conductivity_of_siquid_pcm: "Thermal Conductivity Of Solid PCM",
    heat_trnasfer_coefficient: "Heat Trnasfer Coefficient",
    cm: "cm",
    density_unit: "g/m3",
    deg: "deg",
    thermal_conductivity_unit: "cal/s/cm/deg",
    heating_load: "Heating Load",
    heating_load_unit: "cal/s/cm3",
    switch_on_temperature: "Switch On Temperature",
    switch_off_temperature: "Switch Off Temperature",
    switch_off_temperature_unit: "cal/s/cm3",
    water_vapor_permeability: "Water Vapour Permeability",
    thermal_resistance: "Thermal Resistance",
    temperature: "Temperature",
    membrane_thickness: "Membrane Thickness",
    membrane_type: "Membrane Type",
    membrane_location: "Membrane Location",
    tensile_properties: "Tensile Properties",
    permeability: "Air Permeability",
    tensile_stress: "Tensile Stress(Mpa)",
    tensile_strain: "Tensile Strain(%)",
    pressure_range: "Pressure Range(Pa)",
    flow_rate: "Flow Rate(L/m2/s)",
    feel_skin: "Hand Feel and Skin Comfort",
    heat_simulation: "Thermal Comfort - Simulation Setting",
    heat_file: "Comfort Dat File",
    version_2d: "2D Pattern File",
    fitting_virtual: "Virtual Fitting",
    fitting_virtual_link: "Virtual Fitting Link",
    body_virtual: "Virtual Body Comfort",
    body_virtual_link: "Virtual Body Comfort Link",
    show_virtual: "Virtual Display",
    show_virtual_link: "Virtual Display Link",
    last_time: "Last Time",
    description: "Description",
    status: "Status",
    upload_logo: "Upload Logo",
    role: "Role",
    role_name: "Role Name",
    parent_role: "Parent Role",
    user_name: "User Name",
    password: "Password",
    organization: "Organization",
    department: "Department",
    phone: "Phone",
    email: "Email",
    create_time: "Create Time",
    just_fit: "Just Fit",
    tight_fit: "Tight Fit",
    loose_fit: "Loose Fit",
    comfortable: "Comfortable Indicators",
    quality: "Quality Indicators",
    quality1: "Quality",
    business: "Business Indicators",
    environment: "Environmental Indicators",
    shell: "Shell",
    interlayer: "Interlayer",
    lining: "Lining",
    reference: "Reference Standard",
    indicators_related: "Indicator Association",
    indicator_name: "Indicator Name",
    please_set_hscode: "Please set HS Code first",
    indicator_related_confirm:
      "This operation will modify all indicator displays and reference standards under this item code, do you confirm?",
    search_indicator_name: "Search Indicator Name...",
    indicatorstandards: "Indicator standards",
    database: "Database",
    datauploaded: "Data uploaded",
    uploadMessage: "HS Code related diagrams,video,documents",
    addGroup: "Add Group",
    video: "video",
    document: "document",
    qualityInspectionReport: "Quality Inspection Report",
    pid: "PID",
    plid: "PLID",
    productrevieworganization: "Product Review Organization",
    productImg: "Product Image",
    dataPublicType: "Data Public Type",
    quantity: "quantity",
    mobile: "Phone",
    testPrcie: "Detection Price",
    testCycle: "Detection Period",
  },
  radar_chart: {
    feel: "Hand Feel",
    skin: "Skin Comfort",
    skin_discomfort: "Skin Discomfort",
    heat: "Thermal Comfort",
    softness: "Softness",
    stiff: "Stiff",
    roughness: "Roughness",
    smoothness: "Smoothness",
    warmth: "Warmth",
    total: "Total",
    prickle: "Prickle",
    comfort_value: "Thermal Comfort",
    dampness_sensation: "Dampness Sensation",
    thermal_sensation: "Thermal Sensation",
    average: "Average",
    footprint: "Carbon Footprint",
    recyclable: "Recyclable Index",
    composition: "Composition",
    art: "Aesthetic Comfort",
    layer: "Layer",
  },
  login: {
    helloWord: "Embark on Your Digital Transformation Journey",
    title: "Hello, welcome to FBD!",
    companyOgn: "Company/Organization Name",
    subtitle: "Login and continue to next",
    enter: "Enter",
    username: "Username",
    forgetpassword: "Forget Password",
    password: "Password",
    check_password: "Confirm Password",
    register: "Sign Up",
    registercomplete: "Register and complete information",
    remember: "Remember me",
    login: "Sign In",
    hint_username: "Please enter user name",
    hint_password: "Please enter password",
    logout_title: "Do you want to log out?",
    noAccount: "Don't have an account.",
    chinese: "中文",
    english: "english",
    email: "Email",
    next: "Next Step",
    message1: "Your email will be used as your account",
    message2: "Drag slider  to the far right",
    message3: "Verification successful",
    message4:
      "The verification email has been sent, you can set your password through email!",
    message5: "I have read and accepted",
    message6: "《Terms Of Use》",
    message7:
      "The password must contain at least one uppercase letter, lowercase letter, number, and special characters, with a length more than 8 digits ex:Ft12345#",
    message8: "The two password inputs are inconsistent",
    message9: "Please carefully read the terms of use and check the box",
    message10: "Please enter the correct email address",
    message11: "Please complete slider verification",
    message12:
      "The verification email has been sent, you can reset your password through email!",
    title1: "Register",
    title2: "Reset Password",
    message13: "Register Success",
    confirm: "Confirm",
    agreeAndContinue: "Agree And Continue",
    title3: "Reset Email",
    message14: "Enter the original account password To Check",
    message15: "Email modification successful",
    newEmail: "New Email",
    refeshPicture: "Refesh Picture",
    bar1: "complete the puzzle",
    bar2: "Time",
    bar3: "Validation failed",
    bar4: "complete the puzzle",
    message16: "Please enter your registered email address",
    message17: " 2 seconds later Go to the information improvement page",
    outTime:
      "This link has expired, please fill in the registration information again",
    outTime1:
      "This link has expired, please fill in the reset password information again",
  },
  dashboard: {
    name: "Home Page",
    title: "Home Page",
    input1: "PID/Product Name",
    input2: "OID/Company Name",
    input3: "Quality indicator name",
    input3_1: "Indicator name",
    input4: "PLID/Product Line Name",
    input5: "PLID/Product Line Name/Indicator Name",
    input6: "Search for Testing Agency/Testing Agency OID/Indicator Name",
    input7: "Search for origin and suppliers",
    selectedLength: "Select up to 5 pieces of data",
    selectedLength3: "Select up to 3 pieces of data",
    hScodedescription: "HS Code Description",
    batchtotalquantity: "Batch total quantity",
    supplier: "Merchant Name",
    organizationStructure: "Composition Structure",
    listingTime: "Listing Time",
    evaluate: "Evaluate",
    indicatorValues: "Indicator Values",
    Indicatorunit: "Indicator unit",
    Testingcertificate: "Testing certificate",
    TestingDate: "Testing Date",
    Identificationtestinginstitution: "Code of testing institution",
    Certificationdate: "Detection date",
    Validitycertification: "Validity period of certification qualification",
    Certificationbody: "Certification body",
    Clicktoview: "Click To View",
    dataBaseType: "Product type/Target Market",
    fillDataMessage: "Please complete all data before searching",
    fillDataMessage1:
      "Please select the product type/targetMarket and HS Code before searching",
    indicatorInformation: "Indicator information",
    weight: "Weight",
    value: "Value",
    avg_value: "Avg value",
    total_pef: "Total PEF",
    total_esg: "Total ESG",
    total_circularity: "Total Circularity",
    quality_traceability_diagram: "Quality Traceability Diagram",
    view_indicators: "View Indicators",
    special_indicators: "Special Indicators",
    quality: {
      title: "Quality Dashboard",
      titleText: "Product Digital Passport: Quality",
      titleText1: "List of quality indicators required by regulations/trade",
      titleText2: "Search for products based on quality indicators",
      titleText3: "Search for Testing bodies by quality index",
      mainTitle: "Comparison of Product Quality and Performance",
      titleText4: "Weighted ranking of product quality",
      message: "The sum of weight ratios is not equal to 100%!",
      message1: "The weight ratio cannot be 0!",
      titleText5: "Overall quality rating",
      titleText5_new: "Overall quality indicator performance",
      special_functional_indicators: "Quality special functional indicators",
      titleText6: "0%  pass rate",
      titleText7: "100%  pass rate",
      special_indicators: "Special Indicators",
      titleText8: "Overall quality level of the product",
      titleText9: "Market average quality level",
      titleText10: "Certificate",
      performance_of_Quality_Indicator_Grouping:
        "Performance of Quality Indicator Grouping",
      numerical_performance_of_quality_indicators:
        "Quality Indicator Search - Product Indicator List",
      product_Database: "Quality Indicator Search - Product List",
      inputtext: "Indicator type",
      selectLegnth: "columns have been selected",
      weightRatio: "Weight Ratio",
      tableHeader1: "Regulations/Trade Quality Indicators",
      tableHeader2: "Name of testing institution",
      tableHeader3: "Testing Institution Name OID",
      tableHeader5: "Company OID",
      tableHeader6: "PID QR code",
      tableHeader7: "Indicator group",
      tableHeader8: "Institution QR code",
      tableHeader9: "Testing institution QR code",
      tableHeader10: "Testing price ($)",
      tableHeader11: "Detection cycle (days)",
      tableHeader12: "Company Link",
      tableHeader13: "Email",
      tableHeader14: "Indicator grouping",
      form_contacts: "Contacts",
      mobile: "Mobile Phone",
      pass: "Pass",
      fail: "Fail",
      quality_index_query: "Quality Index Query",
      quality_traceability_diagram: "Quality Traceability Diagram",
    },
    environment: {
      title: "Environmental Footprint Management Dashboard",
      titleText: "Product Digital Passport : Environmental Footprint",
      titleText1:
        "List of Environmental Footprint indicators required by regulations/trade",
      titleText2: "Search for products based on Environmental Footprint",
      titleText3:
        "Search for Testing bodies based on Environmental Footprint index",
      mainTitle: "Comparison of Environmental Footprint indicators",
      titleText4: "Weighted ranking of Environmental Footprint",
      titleText6: "PEF=0",
      titleText7: "The maximum PEF in the open market",
      titleText8: "Overall Product Environmental Footprint (PEF) Level",
      titleText9:
        "Market average level of Product Environmental Footprint (PEF)",
      titleText5_new: "Overall Environmental indicator performance",
      special_environmental_indicators: "Special Environmental Indicators",
      performance_of_pef_Indicator_Grouping:
        "Environmental Footprint indicator grouping performance",
      Performance_subgroups_in_the_climate_index_group:
        "Environmental Footprint Index Search - Product Index List",
      numerical_performance_of_environmental_indicators:
        "Environmental Footprint Index Search - Product List",
      passport_tableHeader1: "Impact category",
      passport_tableHeader2: "Grade",
      passport_tableHeader3: "Normal results",
      passport_tableHeader4: "Weight results",
      passport_tableHeader5: "PEF comprehensive results",
      tableHeader15: "PEF comprehensive index",
      tableHeader16: "Indicator level",
      tableHeader17: "PEF value",
      tableHeader18: "PEF ranking of similar products",
      environment_index_query: "Environment Index Query",
      pef_value: "PEF Value",
      quality_traceability_diagram: "Environmental Footprint Traceability Map",
    },
    esg: {
      title: "ESG Dashboard",
      titleText: "Product Digital Passport : ESG",
      titleText1: "List of ESG indicators required by regulations/trade",
      titleText2: "Search for products based on ESG",
      titleText3: "Search for Testing bodies based on ESG index",
      mainTitle: "Comparison of ESG indicators",
      titleText4: "Weighted ranking of ESG",
      titleText5: "Product ESG Level",
      titleText6: "0%Low performance indicators",
      titleText7: "100%High performance indicators",
      titleText8: "Overall Product ESG Level",
      titleText9: "Market average level of Product ESG",
      titleText10: "PEF Certificate",
      titleText5_new: "Overall ESG indicator performance",
      special_environmental_indicators: "Special ESG Indicators",
      performance_of_pef_Indicator_Grouping:
        "ESG indicator grouping performance",
      Performance_subgroups_in_the_climate_index_group:
        "ESG Index Search - Product Index List",
      numerical_performance_of_environmental_indicators:
        "ESG Index Search - Product List",
      tableHeader15: "ESG comprehensive index",
      esg_index_query: "ESG indicator query",
      esg_value: "ESG comprehensive indicators",
      quality_traceability_diagram: "ESG Traceability Map",
      esg_normalized_average: "ESG Normalized Average",
      esg_normalized_index_value: "ESG Normalization Index Value",
    },
    circularity: {
      title: "Circularity Dashboard",
      titleText: "Product Digital Passport : Circularity",
      titleText1:
        "List of Circularity indicators required by regulations/trade",
      titleText2: "Search for products based on Circularity",
      titleText3: "Search for Testing bodies based on Circularity index",
      mainTitle: "Comparison of Circularity indicators",
      titleText4: "Weighted ranking of Circularity",
      titleText5: "Product Circularity Level",
      titleText6: "0%Low performance indicators",
      titleText7: "100%High performance indicators",
      titleText8: "Overall Product Circularity Level",
      titleText9: "Market average level of Product Circularity",
      titleText5_new: "Overall Circularity indicator performance",
      special_environmental_indicators: "Special Circularity Indicators",
      performance_of_pef_Indicator_Grouping:
        "Circularity indicator grouping performance",
      numerical_performance_of_environmental_indicators:
        "Circularity Index Search - Product List",
      Performance_subgroups_in_the_climate_index_group:
        "Circularity Index Search - Product Index List",
      tableHeader15: "Circularity comprehensive index",
      circularity_index_query: "Circularity indicator query",
      circularity_value: "Circularity comprehensive indicators",
      quality_traceability_diagram: "Circularity Traceability Map",
      circularity_normalized_average: "Circularity Normalized Average",
      circularity_normalized_index_value:
        "Circularity Normalization Index Value",
    },
    comfort: {
      title: "Sensory comfort Dashboard",
      titleText: "Product Digital Passport : Sensory comfort",
      titleText1:
        "List of Sensory comfort indicators required by regulations/trade",
      titleText2: "Search for products based on Sensory comfort",
      titleText3: "Search for Testing bodies based on Sensory comfort index",
      mainTitle: "Comparison of Sensory comfort indicators",
      titleText4: "Weighted ranking of Sensory comfort",
      titleText5: "Product Sensory comfort Level",
      titleText6: "0%Low performance indicators",
      titleText7: "100%High performance indicators",
      titleText8: "Overall Product Sensory comfort Level",
      titleText9: "Market average level of Product Sensory comfort",
      titleText10: "PEF Certificate",
      titleText5_new: "Overall Sensory comfort indicator performance",
      special_environmental_indicators: "Special Sensory comfort Indicators",
      performance_of_pef_Indicator_Grouping:
        "Sensory comfort indicator grouping performance",
      Performance_subgroups_in_the_climate_index_group:
        "Sensory comfort Index Search - Product Index List",
      numerical_performance_of_environmental_indicators:
        "Sensory comfort Index Search - Product List",
      comfort_index_query: "Sensory comfort indicator query",
      circularity_value: "Sensory comfort comprehensive indicators",
      quality_traceability_diagram: "Sensory comfort Traceability Map",
      comfort_normalized_val: "Sensory comfort Normalized Value",
      product_name: "Product Name",
      fabric_name: "Fabric Name",
    },
    traceability: {
      title: "Traceability Dashboard",
      titleText: "Product Digital Passport : Traceability",
      mainTitle: "Products List",
      placeholder1: "Please select the type of data disclosure",
      titleText6: "0%Low performance indicators",
      titleText7: "100%High performance indicators",
      titleText5_new: "Overall Traceability indicator performance",
      special_environmental_indicators: "Special Traceability Indicators",
      performance_of_pef_Indicator_Grouping:
        "Traceability indicator grouping performance",
      origin_traceability_map: "Origin traceability map",
      traceability_map: "Traceability map",
      origin_traceability: "Origin traceability",
    },
  },
  garment: {
    name: "Garment",
    title: "Garment Database",
    add: "Add New Garment",
    edit: "Edit Garment Profile",
    detail: {
      title: "Garment Profile",
    },
    version: "Garment Patterns",
    keyword_placeholder: "ID/Name/Type/Supplier/Brand",
  },
  fabric: {
    name: "Fabric",
    title: "Fabric Database",
    add: "Add New Fabric",
    edit: "Edit Fabric Profile",
    comfortable_base: "Comfortable BaseInfo",
    detail: {
      title: "Fabric Profile",
      water: "Moisture Management Properties",
      membrane: "Membrane Properties",
      disguised: "Phase Change Material",
      heat: "Self Heating",
      ftt: "FTT",
      liquid_water_conductivity: "mmt",
      sst: "Spreading speed at top surface(SST)",
      ssb: "Spreading speed at bottom surface(SSB)",
      r: "Accumulative one-way transport capacity(R)",
      ommc: "Overall moisture management capability(OMMC)",
      top_water_contact_angle: "Top Water Contact Angle",
      bottom_water_contact_angle: "Bottom Water Contact Angle",
    },
    no_layers: "No.of Fabric",
    id: "Fabric ID",
    structure: "Fabric Structure",
    structure_layer: "Fabric Structure Layer",
    color: "Fabric Color",
    thickness: "Fabric Thickness ",
    thickness_unit: "cm",
    weight: "Fabric Weight",
    weight_unit: "g/m2",
    density: "Fabric Density",
    density_unit: "g/m3",
    tortuous: "Fabric Tortuous gas",
    porosity: "Fabric Porosity gas",
    keyword_placeholder: "ID/Name/Type/Supplier",
    tips: "Textile Fabric Touch Determination and Evaluation Method: Multi-Index Integration Method",
  },
  yarn: {
    name: "Yarn",
    title: "Yarn Database",
    add: "Add New Yarn",
    edit: "Edit Yarn Profile",
    detail: {
      title: "Yarn Profile",
    },
    id: "Yarn ID",
    percentage: "Yarn Percentage",
    percentage_unit: "%",
    type: "Yarn Type",
    linear_density: "Yarn Linear Density",
    linear_density_unit: "tex",
    diameter: "Yarn Diameter",
    diameter_unit: "mm",
    twist: "Yarn Twist",
    twist_unit: "twist/meter",
    keyword_placeholder: "ID/Type/Supplier/Brand",
  },
  hscode: {
    name: "HS Code",
    description:
      "HS Code is a collection of various standards for products in the system",
    title: "HSCODE MANAGEMENT",
    parentclassencoding: "Parent Class Encoding",
    encodingtype: "Encoding Type",
    encodingName: "Encoding Name",
    add: "Add HS Code",
    edit: "Edit HS Code",
    delete: "Delete HS Code",
    searchPlaceholder: "Search HS Code By Code",
    addIndicator: "Add Indicator",
    addIndicator1: "Add Indicator",
    indicatorName: "Indicator Name ",
    indicatorName1: "Standard Name",
    groupName: "GroupName",
    category_name: "Indicator Category",
    deleteGroup: "Delete Group",
    dataBase: "DataBase",
    encodingId: "Encoding ID",
    detailTitle: "HS Code MANAGEMENT",
    filterHscode: "Filter HS Code By Name",
    requiredHscode: "Please select HS Code",
    requireProduct: "Please select Product review organization", //
    requiredIndicatorName: "Please fill in the indicator info",
    requiredIndicatorFile:
      "Please upload the attachment of the indicator report",
    requirePID: "Please fill in the PID", //Product review organization
    requirePLID: "Please fill in the PLID", //Product review organization
    descriptionLong: "Description input length cannot exceed 200",
    createProductsAtThisLevel: "Create HS Code at this level",
    message: "Please fill in 4 digits",
    message1: "Please fill in 6 digits",
    messageLength: "Please fill in the correct length",
    hsCodeFourLength: "4-digit HS Code",
    hsCodeSixLength: "6-digit HS Code",
    message2: "Please fill in the name of the product category",
    subItemCode: "Sub Item Code",
    fill: "Please fill",
    productCode: "Product Code",
    indexClassification: "Index Classification",
    add_indicator_type: "Add Indicator Type",
    delete_indicator_type: "Delete Indicator Type",
    add_group_type: "Add indicator group",
    group_type_name: "Indicator group name",
    delete_group_type: "Delete indicator group",
    add_group_son_type: "Add indicator sub group",
    group_son_type_name: "Indicator sub group name",
    delete_group_son_type: "Delete indicator sub group",
    threshold: "Threshold",
    standard_judgment_method: "Judgement model",
    is_it_applicable: "Is applicable",
    is_special_indicator: "Is special indicator",
    type: {
      yes: "Yes",
      no: "No",
    },
    calculation_mode: "calculation mode",
    sameGroupName: "Duplicate indicator group names",
    sameSubGroupName: "Duplicate indicator sub group names",
    same_category_name: "Duplicate indicator types",
    same_group_subGroup_name:
      "Duplicate indicator group name or Indicator sub group name",
    target_market: "Target market",
    target_market_description:
      "The target market will divide the HS Code into different regional versions, and it is recommended to fill it in at the bottom level",
    target_market_code: "Target market code",
    target_market_code_description:
      "Fill in the destination market code, which will be an important component of PID",
    needInfo:
      "When yes, it is necessary to fill in some threshold values and compliance methods",
    indicator_group: "Indicator Group", //指标组
    indicator_sub_group: "Indicator Sub Group",
    expand: "Expand",
    collapse: "Collapse",
  },
  product_template: {
    title: "Product Database Management",
    add: "Add Product Database",
    searchPlaceholder: "Search Product Template Name",
    searchPlaceholder1: "Search HS Code, Target Market ",
    templateName: "Template Name",
    productTemplateName: "Product Template Name",
    productTemplateName1: "Product Database Name",
    update_time: "Last Modified Time",
    template_info: "Product Additional Information",
    hscodeDatabase: "HS Code Database",
    hscodeDatabase1: "HS Code",
    description: "Description",
    publicType: "PublicType",
    plid: "PLID",
    pid: "PID",
    productrevieworganization: "Product Review Organization",
    addField: "Add Field",
    productInfo: "Product Info",
    comfortInformation: "Comfort Information",
    qualityInspectionReport: "QualityInspection Report",
    otherInfo: "Other Info",
    basicInfo: "Basic Info",
    productName: "Product Name",
    type: "Type",
    inventory: "Inventory",
    price: "Price",
    size: "Size",
    color: "Color",
    batch: "Batch",
    batchValue: "Batch Number",
    compositionStructure: "Composition Structure",
    number: "Number",
    structure: "Structure",
    proportion: "Proportion",
    searchProducts: "Search",
    selectDataBase: "Please select a product database ",
    productImg: "Product Image",
    text: "Text Name",
    thermalComfortDat: "Heat and humidity comfort Dat File",
    heatandhumiditycomfort: "Heat and humidity comfort",
    ftt: "Fabric Tactile Test",
    liquid_water_conductivity: "Liquid moisture conductivity of fabrics",
    bottom_water_contact_angle: "Bottom Water Contact Angle",
    membrane: "Membrane",
    disguised: "Disguised",
    heat: "Self Heating",
    enterFieldName: "Field Name",
    requeiredInfo: "You need to write something!",
    requeiredInfo1: "Please input",
    requeiredInfo2: "Custom field name!",
    requeiredproductInfoFieldName:
      "Please enter a custom field name for product information!",
    requeiredcomfortInfoFieldName:
      "Please enter a custom field name for comfort information!",
    requeiredotherInfoFieldName:
      "Please enter a custom field name for other information!",
    targetmarket: "Target market",
    requeiredcompositionStructureValue:
      "Please select the composition structure information!",
    noTemplateInfo: "No information was found for this template!",
    upload_info:
      "Support. png,. jpeg,. jpg,. dwg,. dwt,. dxf,. dwf,. mp4,. mov,. avi file sizes not exceeding 50M",
    testingOrganization: "Testing Organization",
    testingOrganizationQualification: "Testing Organization Qualification",
    report: "report",
    report1: "Testing Report",
    remark: "remark",
    requeiredindicatorstandards: "Please fill in all indicator information",
    origin: "Origin",
    productLine: "Product Line",
    productLineNo: "Product Line No",
    productTime: "Product Time",
    requireCompositionStructure:
      "Please improve the composition structure information",
    compositionStructureSum:
      "The sum of organizational structure ratios cannot exceed 100",
    compositionStructureError:
      "When there is only one component in the structure, please select the lining",
    requireupload: "Please complete the upload of image information",
    annex: "Annex",
    createTimeRange: "Create Time Range",
    requiredIndicato1: "Please select indicators",
    dataBaseNoOpen: "The product database is not enabled",
    checkerr:
      "When the composition structure is empty, mandatory fields cannot be checked",
    warningInfo:
      "After closing the database, all products using this template will be taken down!",
    testDate: "Test date",
    testinginstitutions:
      "Validity period of qualification certification for testing institutions",
    testinginstitutions1: "Testing Agency Qualification Certification Agency",
    deleteTitle:
      "Deleting the template data will remove all product data in the database, and this data cannot be recovered. Please delete with caution.",
    integerMessage:
      "Please fill in an integer of ≥ 0 for inventory or batch quantity",
    priceMessage:
      "Please fill in the price as an integer or decimal with a value of ≥ 0, and the decimal length should not exceed 2 digits",
    repeatMessage: "Duplicate module names",
  },
  products: {
    name: "Product Name",
    title1: "Products List",
    title: "Products Details",
    subtitle: "Clothing Products",
    add: "Add Product Details",
    searchPlaceholder: "Search Products",
    supplier: "Merchant",
    pubnishTime: "Published",
    customerReview: "Customer Review",
    order: "No. of Orders",
    availableStocks: "Available Stocks",
    description: "Description",
    basicInfo: "Basic Info",
    productdetails: "Product Details",
    size: "Sizes",
    color: "Colors",
    all: "All",
    notpublic: "Not public",
    Opasc: "Publicly available to the supply chain",
    completelypublic: "Completely public",
    uploadMuti: "Batch Upload",
    message1: "Please enter the name of the testing agency in the report",
    message2:
      "Please enter the qualification of the testing institution in the report",
    loseTemplateName: "Missing template name",
    status: "Review status",
    message3: "Please enter the detection date",
    message4:
      "Please enter the validity period of the qualification certification of the testing institution",
    message5:
      "Please enter the qualification certification agency for the testing institution",
    message6: "No permission for this database",
    message7: "There is no HS Code product line available",
    message8:
      "There will be a PID conflict between the copied product and the original product. Please make sure to modify it accordingly",
    advanced_search: "Advanced Search",
  },
  account: {
    title: "Account Management",
    title1: "My Review Info",
    subtitle: "Register Member",
    info: "We need to collect your company information in order to provide you with a better user experience",
    info1: "Go improve the information",
    progressInfo1: "Account information",
    progressInfo2: "Enterprise/Organizational Information",
    progressInfo3: "Submit Application",
    form_companyName: "Company/Organisation Name",
    form_companyName_placeholder: "Please enter the company/organization name",
    form_username_placeholder: "Please enter your account email address",
    form_email_placeholder: "Please enter your contact email address",
    form_Enterprisetype: "Enterprise Type",
    form_contacts: "Contacts",
    form_Enterprisetype_placeholder: "Please select your business type",
    form_contacts_name: "Name", //Please enter the full name of the contact person
    form_contacts_xing: "Surname",
    form_email: "Contact Email (Username)",
    form_phone: "Landline number",
    form_phone_number: "phone_number",
    form_main_business_areas: "Main Business Aareas",
    form_main_business_areas_placeholder:
      "Please select your main business area",
    from_is_certification_company: "Certification organization",
    from_is_check_company: "Testing organization",
    from_is_certification_company_placeholder:
      "Please select whether it is a certification organization",
    from_is_check_company_placeholder:
      "Please select whether it is a testing organization",
    form_Enterprise_registered_address: "Enterprise Registered Address",
    form_Certificate_No: "Certificate No",
    form_qualification_documents: "Qualification Documents",
    form_country: "Country",
    form_province: "Province",
    form_province_code: "Province Code",
    form_province_code_placeholder: "Please enter uppercase letters",
    form_City: "City/District",
    form_address: "Address",
    form_post: "Post",
    enterprise_production_address: "Enterprise Production Address",
    contact_address: "Enterprise mailing address",
    btn_add_production_address: "Add Enterprise Production Address",
    btn_back: "Back",
    btn_submit: "Submit",
    btn_submit_success: "Success",
    progressInfo4:
      "Your application has been submitted and we will complete the review within three working days. Please be patient and wait!",
    progressInfo5:
      "The information you submitted cannot prove your role in the industry. Please provide complete company information!",
    btn_complete: "Complete Information",
    progressInfo6:
      "The information you submitted has been reviewed and approved",
    rejectReason: "Reason for rejection",
    no_wait_review_info: "No wait_review_info",
    logo: "Enterprise logo",
    backToLogin: "Return to the login page",
    contactAddress: "Contact person's mailing address",
    form_qualification_certification:
      "Validity period of institutional qualification certification",
    form_qualification_certification1:
      "Institutional Qualification Certification Institution",
    form_company_link: "Company's website",
    form_test_date_placeholder1:
      "Please select the validity period of institutional qualification certification",
    form_test_date_placeholder2:
      "Please enter the institution qualification certification agency",
    form_test_date_placeholder3: "Please enter the company's website link",
    tab1: "Price configuration for inspection",
    product_address_info:
      "Manufacturers and suppliers need to fill in complete production address information",
  },
  supplyChain: {
    placeholder1: "Search for supply chain names",
    placeholder2: "Types of supply chains",
    placeholder3: "Select Supply chain start time",
    tableHeader1: "Supply chain name",
    tableHeader1_1: "Company name",
    tableHeader2: "Supply chain start time",
    tableHeader3: "Supply chain close time",
    add: "Add Supply chain",
    edit: "Edit Supply chain",
    detail: "Supply chain Detail",
    setting: "Supply chain configuration",
    setting_role: "Supply chain roles",
    name: "Supply Chain",
    company_name_repeat: "Company name repeat",
  },
  business_information_management: {
    title: "Business User Management",
    subtitle: "Business User Approval",
    subtitle11: "Business User Approval List",
    subtitle1: "Business User Approval Detail",
    subtitle2: "Business User Detail",
    search_placeholder:
      "Search for company name, contact person, and phone number",
    search_placeholder1: "Select Registration Date",
    search_placeholder2: "Select Enterprise Type",
    search_placeholder3: "Select Enterprise registration location",
    tab1: "Pending Approval",
    tab2: "UnApproval",
    tab3: "Approval",
    registre_time: "Registre Time",
    newUser: "New User",
    examine: "Account info Examine",
    examine1: "Enterprise/Organizational Information Examine",
    examine2: "Permission Configuration",
    examine3: "Review Comments",
    examine4: "Reject Application",
    viewfile: "View File",
    thirdCompany: "Third party certification company",
    testingOrganization: "Testing organization",
    lastLoginTime: "Last login time",
    passport: "Digital Organization Passport",
    detail_tab1: "Enterprise Information",
    detail_tab2: "Power Information",
    rejectedsuccessfully: "Rejected Successfully",
    please_input_reject_reason: "please input reject reason",
    functionalpermissions: "Functional Permissions",
    noUserPermissions: "User permissions not configured",
    examineSuccess: "User review successful",
    examineing: "In review",
    accountEmail: "Account",
    disableAccount: "Are you sure to disable this account?",
    disableAccountResult:
      "After disabling, users will not be able to log in to the system!",
  },
  business_products_management: {
    title: "Product Certification Management",
    subtitle: "Product List",
    subtitle1: "Product Information Approval Detail",
    subtitle2: "Product Information Detail",
    search_placeholder: "Search Company/Organization Name",
    search_placeholder1: "Select submission date",
    tab1: "Unaudited",
    tab2: "Not Passed",
    tab3: "Detection passed",
    tab4: "Certification passed",
    tableHeader1: "Company/Organization Name",
    tableHeader2: "Submission Date",
    reject: "Reject",
    testedSuccessfully: "Detected",
    certificationPassed: "Certified",
    reject_reason: "Reject Reason",
    input_reject_reason: "Please enter Reject Reason",
    passed_successfully: "Passed Successfully",
    delete_alert_title: "Are you sure you want to delete this product?",
    delete_alert_info:
      "This action will delete the product submitted by the user. Please proceed with caution!",
    updatedHSCode: "Updated HS Code",
    updatedTemplate: "Updated Product Database",
  },
  product_line: {
    title: "Production line management",
    subTitle: "Production line management",
    searchPlaceholder: "Search for product line name、targetmarket",
    searchPlaceholder1_1: "Please Select product line Typ",
    searchPlaceholder2: "Please Select HS Code, Target Market",
    searchPlaceholder1: "Product Type",
    table_header: "Production line number",
    table_header_searchPlaceholder:
      "Please enter a 6-digit code,Combination of uppercase letters and numbers",
    table_header1: "Product Line Name",
    table_header1_searchPlaceholder: "Please enter the product line name",
    table_header2: "PLID",
    table_header3: "Clothing Style",
    table_header4: "Design Template",
    table_header5: "HS Code",
    table_header6: "Origin",
    table_header7: "Target market",
    searchPlaceholder3: "Please Select Target market",
    add: "Create Product Line",
    upload_info:
      "Support. png,. jpeg,. jpg,. dwg,. dwt,. dxf,. dwf,. mp4,. mov,. avi files, with a file size not exceeding 50M",
    product_line_no_length:
      "Please fill in the 6-digit length product line number",
    modify_product_line: "Modify Product Line",
    product_line_detail: "Product line detail",
    message:
      "Platform management requirements, some content needs to be supplemented to improve product information",
    seach_product_line_name: "Search product line name",
  },
  fiber: {
    name: "Fibre",
    title: "Fibre Database",
    add: "Add New Fibre",
    edit: "Edit Fibre Profile",
    detail: {
      title: "Fibre Profile",
    },
    id: "Fibre ID",
    type: "Fibre Type",
    percentage: "Fibre Percentage",
    percentage_unit: "%",
    density: "Fibre Density",
    density_unit: "g/cm3",
    diameter: "Fibre Diameter",
    diameter_unit: "mm",
    thermal_conductivity: "Fibre Thermal Conductivity",
    thermal_conductivity_unit: "W/(m*k)",
    moisture_regain: "Moisture Regain",
    moisture_regain1: "Regain(%)",
    water_contact_angle: "Water Contact Angle",
    water_contact_angle_unit: "deg",
    water_diffusion_coefficient: "Water Diffusion Coefficient",
    water_diffusion_coefficient_unit: "m2/s",
    relative_humidity: "RH(%)",
    keyword_placeholder: "ID/Type/Supplier/Brand",
  },
  hometextile: {
    name: "Hometextile",
    title: "Hometextile Database",
    add: "Add New Hometextile",
    edit: "Edit Hometextile Profile",
    detail: {
      title: "Hometextile Profile",
    },
    version: "Hometextile Patterns",
    keyword_placeholder: "ID/Name/Type/Supplier/Brand",
  },
  textile: {
    name: "Industrial Textiles",
    title: "Industrial Textiles Database",
    add: "Add New Industrial Textiles",
    edit: "Edit Industrial Textiles Profile",
    detail: {
      title: "Industrial Textiles Profile",
    },
    version: "Industrial Textiles Patterns",
    keyword_placeholder: "ID/Name/Type/Supplier/Brand",
  },
  textile_kitchen: {
    name: "Kitchen and Bathroom Supplies",
    title: "Kitchen and Bathroom Supplies List",
    add: "Add Kitchen and Bathroom Supplies",
    edit: "Edit Kitchen and Bathroom Supplies",
    detail: {
      title: "Kitchen and Bathroom Supplies Profile",
    },
    version: "Kitchen and Bathroom Supplies Patterns",
    keyword_placeholder: "ID/Name/Type/Supplier/Brand",
    parent: "Industrial Textiles Patterns",
  },
  textile_bedware: {
    name: "Bedding",
    title: "Bedding List",
    add: "Add Bedding",
    edit: "Edit Bedding",
    detail: {
      title: "Bedding Profile",
    },
    version: "Bedding Patterns",
    keyword_placeholder: "ID/Name/Type/Supplier/Brand",
    parent: "Hometextile Database",
  },
  textile_home_decor: {
    name: "Household Textiles",
    title: "Household Textiles List",
    add: "Add Household Textiles",
    edit: "Edit Household Textiles",
    detail: {
      title: "Household Textiles Profile",
    },
    version: "Household Textiles Patterns",
    keyword_placeholder: "ID/Name/Type/Supplier/Brand",
    parent: "Hometextile Database",
  },
  textile_industrial: {
    name: "Industrial Textiles",
    title: "Industrial Textiles List",
    add: "Add Industrial Textiles",
    edit: "Edit Industrial Textiles",
    detail: {
      title: "Industrial Textiles Profile",
    },
    version: "Industrial Textiles Patterns",
    keyword_placeholder: "ID/Name/Type/Supplier/Brand",
    parent: "Industrial Textiles Patterns",
  },
  role: {
    name: "Role",
    title: "Role List",
    add: "Add New Role",
    edit: "Edit Role",
    detail: {
      title: "Role Information",
    },
    keyword_placeholder: "Role Name",
    hint_role_name: "The role name cannot be empty!",
    emptyRole: "Please create a role first",
  },
  user: {
    name: "User",
    title: "User List",
    add: "Add New User",
    edit: "Edit User",
    detail: {
      title: "User Information",
    },
    keyword_placeholder: "User Name",
    hint_name: "The name cannot be empty!",
    hint_user_name: "The username cannot be empty!",
    hint_password: "The password cannot be empty!",
    hint_role: "The role cannot be empty!",
  },
  permission: {
    name: "Permission",
    title: "Permission",
    role: "Role List",
    permission: "Permission",
  },
  lang: {
    functional_classification: "Functional classification",
    menu: "Menu",
    home: "Home Page",
    hscode: "HS Code",
    product_template: "Product Template",
    products: "Products Mangaement",
    business_information_management: "Business User Management",
    business_products_management: "Product Certification Management",
    product_line: "Product Line Management",
    account: "Enterprise Account Management",
    supplyChain: "Supply Chain Management",
    search: "Search",
    key: "Key",
    description: "Description",
    ch: "中文",
    en: "英文",
  },
  smooth: "Smooth",
  rough: "Rough",
  soft: "Soft",
  stiff: "Stiff",
  prickle: "Prickle",
  cool: "Cool",
  warm: "Warm",
  comfortable: "Comfortable",
  uncomfortable: "Uncomfortable",
  discomfort: "Discomfort",
  dry: "Dry",
  damp: "Damp",
  garmentProfile: "Garment Profile",
  fabricProfile: "Fabric Profile",
  yarnProfile: "Yarn Profile",
  fibreProfile: "Fibre Profile",
  homeTextileProfile: "Home Textile Profile",
  industrialTextileProfile: "Industrial Textile Profile",
};
